import { useContext, useState } from "react";
import { ensure } from "sprint-common-web";

import { useManzanitaPresetApi } from "../../../../../common/api/orders-api/manzanita-preset/useManzanitaPresetApi";
import { blobToBase64 } from "../../../../../orders/orders/common/blobToBase64";
import { ManzanitaPresetListingContext } from "../../context/ManzanitaPresetListingContext";
import { EditManzanitaPresetFormInputs } from "./EditManzanitaPresetForm";

interface FormFile {
    name: string;
    body: string;
    size?: number;
}

export const useEditManzanitaPresetForm = (currentFilePath: string) => {
    const { editManzanitaPreset: editPreset } = useManzanitaPresetApi();
    const { editItem } = useContext(ManzanitaPresetListingContext);
    const [formFile, setFormFile] = useState<FormFile | undefined>({ name: currentFilePath, body: "" });
    const [isFileDropped, setIsFileDropped] = useState<boolean>(true);

    const dropFile = async (file: File): Promise<void> => {
        const encodedPreset = await blobToBase64(file);

        setFormFile({ name: file.name, body: encodedPreset, size: file.size });
        setIsFileDropped(true);
    };

    const clearFile = () => {
        setIsFileDropped(false);
        setFormFile(undefined);
    };

    const editManzanitaPreset = async ({ id, name }: EditManzanitaPresetFormInputs) => {
        ensure(formFile);

        await editPreset({
            id,
            name,
            filePath: formFile?.name,
            encodedPreset: formFile.body
        });

        editItem({
            id,
            name,
            filePath: formFile?.name,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        editManzanitaPreset,
        dropFile,
        clearFile,
        formFile,
        isFileDropped
    };
};
